import { v4 as uuid } from 'uuid';
import {
  BindersApi,
  BookshelvesApi,
  CustomersApi,
  UsersApi
} from '../../Utils/apis';
import { iBinderFetch } from '../../Utils/iBinderFetch';
import {
  CleanupImpersonation,
  ImpersonateUser
} from '../../Utils/ImpersonateUser';
import { EventLog } from '../../Utils/eventLogger';

const id = uuid();
const githubUrl = `https://github.com/iBinder/admins-ui/tree/main/${__filename}`;

// *****************************************************************************
// START - The part between START and END is the part that is added to the file.
// *****************************************************************************
const name = 'First binder on users first bookshelf';
const description =
  'Given an user id this function gets the first binder on the first bookshelf for the given user';

// The input model
export interface AddInput {
  userId?: string;
  documentId?: string;
}

// The sample input, prefilled in the editor
const sample: AddInput = {
  documentId: 'förifyllt',
  userId: '6fde6b81-f84c-4fd0-df74-08d7daf43f3f'
}; //Sani

// The actual function called with the input
const fn =
  ({ tenantId }) =>
  async ({ userId }: AddInput) => {
    const tenantFetch = iBinderFetch({ tenantId });

    const impersonateResponse = await ImpersonateUser({ userId });

    await EventLog({ WillOscarLoveMe: 'YES!' });
    const User = await tenantFetch(`${UsersApi}/${userId}`);

    const Bookshelves = await tenantFetch(`${BookshelvesApi}/`);

    const bookshelfves_response = await Bookshelves.json();
    await EventLog({ ShowMeTheBookshelvesResponse: bookshelfves_response });

    const Binders = await tenantFetch(
      `${BookshelvesApi}/${bookshelfves_response[0].id}/Binders?includeLegacy=true`
    );

    const Binders_response = await Binders.json();

    const theBookshelfBinder = Binders_response.data.filter(
      (b) => b.type !== 'Procurement'
    )[0];

    // Override, I want a new special fetch and do not want to care about tenantid from the input.
    const newTenantFetch = iBinderFetch({
      tenantId: theBookshelfBinder.tenantId
    });

    const binderInformation = await (
      await newTenantFetch(`${BindersApi}/${theBookshelfBinder.binderId}`)
    ).json();
    await CleanupImpersonation();

    return JSON.stringify({
      theUser: await User.json(),
      theBookshelfBinder: theBookshelfBinder,
      binderInformation
    });
  };

// *****************************************************************************
// END - The part between START and END is the part that is added to the file.
// *****************************************************************************

export default {
  onSubmit:
    ({ tenantId }) =>
    async (jsonData) =>
      await fn({ tenantId })(jsonData),
  sample,
  id,
  name,
  description,
  githubUrl
};
